import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * /auth/sso/error — Renders a generic SSO failure message.
 * The ?code= query parameter is available for support debugging but is never
 * rendered verbatim to avoid leaking IdP-side error details to end users.
 */
export function SsoErrorPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-base px-4">
      <div className="w-full max-w-sm text-center">
        <div className="mb-6 flex justify-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-status-error/10">
            <AlertTriangle className="h-7 w-7 text-status-error" />
          </div>
        </div>
        <h1 className="text-xl font-bold text-text-primary">Sign-in failed</h1>
        <p className="mt-3 text-sm text-text-secondary">
          We couldn't complete your SSO sign-in. This may be a temporary issue.
          Please try again or contact your administrator if the problem persists.
        </p>
        <div className="mt-8 flex flex-col gap-3">
          <Button asChild>
            <a href="/auth/sso/start">Try again</a>
          </Button>
          <Button variant="outline" asChild>
            <a href="/login">Sign in with password</a>
          </Button>
        </div>
      </div>
    </div>
  );
}
